import { createApp, h } from 'vue'
import { createInertiaApp, Link } from '@inertiajs/inertia-vue3'
import Button from './Vue/Utilities/Button.vue';
import BackgroundImage from './Vue/Utilities/BackgroundImage.vue';
import Burn from './Vue/Utilities/Burn.vue';
import SmoothLink from './Vue/Utilities/SmoothLink';
import SmoothLoader from './Vue/Utilities/SmoothLoader.vue';

const $ = window.jQuery;

window.wait = async function (ms) {
    return new Promise(resolve => {
        window.setTimeout(resolve, ms);
    });
}

window.prefersReducedMotion = () => {
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mediaQuery || mediaQuery.matches) {
        return true;
    } else {
        return false;
    }
};

window.rand = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
};

$.fn.isInViewport = function(offset = 0) {

    var top_of_element = this.offset().top + offset;
    var bottom_of_element = this.offset().top + this.outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();

    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        return true;
    } else {
        return false;
    }

};

createInertiaApp({
  resolve: name => require(`./Vue/${name}`),
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .component('BackgroundImage', BackgroundImage)
      .component('Button', Button)
      .component('Burn', Burn)
      .component('SmoothLoader', SmoothLoader)
      .component('Link', SmoothLink)
      .mount(el)
  },
});
